import React from "react";
import { SwitchButton } from "_common/ui/components/SwitchButton";
import { MAP_OR_LIST_SELECTED, usePropertiesPageContext } from "properties/PropertiesPageContext";
import { useTranslation } from "react-i18next";

export function SwitchButtonMapList() {
    const { t } = useTranslation();
    const { mapOrListSelected, setMapOrListSelected } = usePropertiesPageContext();
    return (
        <SwitchButton
            className={"hiddenMobile"}
            value={mapOrListSelected === MAP_OR_LIST_SELECTED.MAP}
            onChange={() =>
                setMapOrListSelected(
                    mapOrListSelected === MAP_OR_LIST_SELECTED.MAP
                        ? MAP_OR_LIST_SELECTED.LIST
                        : MAP_OR_LIST_SELECTED.MAP,
                )
            }
            labelOn={t("propertiesPage.list")}
            labelOff={t("propertiesPage.map")}
        />
    );
}
